import { styled } from 'baseui'
import { pollColor } from '@/shared/tools/communicationBoardPolls'

export const BarRow = styled('li', {
  display: 'grid',
  gridTemplateColumns: '1.5rem 9rem 1fr 4.5rem',
  alignItems: 'center',
  gap: '0.5rem',
})

export const FaceSwatch = styled<'span', { $colorKey: string }>('span', ({ $theme, $colorKey }) => ({
  display: 'inline-flex',
  color: pollColor($theme, $colorKey),
}))

export const BarLabel = styled('span', ({ $theme }) => ({
  fontSize: '0.75rem',
  color: $theme.colors.textPulseLabel,
}))

export const BarTrack = styled('span', ({ $theme }) => ({
  display: 'block',
  height: '0.5rem',
  overflow: 'hidden',
  borderRadius: '999px',
  backgroundColor: $theme.colors.bgPulseTrack,
}))

export const BarFill = styled<'span', { $colorKey: string; $share: number }>(
  'span',
  ({ $theme, $colorKey, $share }) => ({
    display: 'block',
    width: `${$share}%`,
    height: '100%',
    borderRadius: '999px',
    backgroundColor: pollColor($theme, $colorKey),
  }),
)

export const BarCount = styled('span', ({ $theme }) => ({
  fontSize: '0.75rem',
  fontVariantNumeric: 'tabular-nums',
  textAlign: 'right',
  color: $theme.colors.textPulseMuted,
}))
